<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
<!--                <base-input v-model="username" alternative-->
<!--                            class="mb-3"-->
<!--                            v-mask="'#######-#'"-->
<!--                            placeholder="Número de inscrição"-->
<!--                            addon-left-icon="ni ni-single-02">-->
<!--                </base-input>-->
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '1234567-8',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX1/QTQi2AJnaeZU9pBlWMOVR8JkVs0QvMVQ=",
    "cpf": "U2FsdGVkX18zonkd/KEvGm94aa+hGv82NAuoluF5ha8="
  },
  {
    "num_cand": "U2FsdGVkX1+4IV2z+1jjWUjTqVtjMsbAWdrEUHqe9lA=",
    "cpf": "U2FsdGVkX19EPszX9ibb3GLQVUE/bEi85UhkHSvILOk="
  },
  {
    "num_cand": "U2FsdGVkX1/g0HBZA2pWo7ToNPlLyfxR82zJEx6SHDQ=",
    "cpf": "U2FsdGVkX1+J0bgNWC9PyvzYZaM7wAvj3fb7hVje0Aw="
  },
  {
    "num_cand": "U2FsdGVkX19G86A8JA1dSqO9L6UjeHlpJSt8Q6h1w8w=",
    "cpf": "U2FsdGVkX19t47eezypugFnYZzhNfNExPU9mupIi83c="
  },
  {
    "num_cand": "U2FsdGVkX1+sd0Z0XK2VqkZfnHaBVnHmRntC6jS+QEk=",
    "cpf": "U2FsdGVkX19CYJwZS3/A2BFBUeJD3r5VvRiyPHwsFOg="
  },
  {
    "num_cand": "U2FsdGVkX1/aiV5z5PEUBqAxiE8e+HCadXpb1FBHxnw=",
    "cpf": "U2FsdGVkX1+MRzKLcbJsRY1Fv5Z4aSTR7eETTWLczno="
  },
  {
    "num_cand": "U2FsdGVkX18Bc5OWqLbxMjwkG5IkbpwOg6Wr0ROi3os=",
    "cpf": "U2FsdGVkX1/+szjR/QViZKA98Ti+F3cfgV+ohR0+ZKM="
  },
  {
    "num_cand": "U2FsdGVkX1/P0YSteyhP9hgugyzgDeDtT7DXUOqK5mw=",
    "cpf": "U2FsdGVkX1/h8qiAuxFzaoy/pFdFVsN98AYn3uxGdpM="
  },
  {
    "num_cand": "U2FsdGVkX19Q1uQADzSK8HtOIm8HlLt+z/lfkyPdzpk=",
    "cpf": "U2FsdGVkX1/hYd8dFgdBCg8Xx3G6YBNpzoSFjJBmvfU="
  },
  {
    "num_cand": "U2FsdGVkX1/8F0w3be/VE8gIb+lcuvcAs0lgyYAu85k=",
    "cpf": "U2FsdGVkX19FRyqN1SLnjttUUbMiPt7rsGqe1ee0fGc="
  },
  {
    "num_cand": "U2FsdGVkX1+47KuRFgZkuh2+0vGpRXDc71dsp1eeAGU=",
    "cpf": "U2FsdGVkX1+9VfpqKZ4Cz7AbSpqO+AVe1h0fzRkOhC0="
  },
  {
    "num_cand": "U2FsdGVkX18T1cYhJ2WFRpNsFV2kNmRsK9hR3+9OLTY=",
    "cpf": "U2FsdGVkX19DdsyB9ZtlhJZHlYuwGmrPsDmT8Talkgk="
  },
  {
    "num_cand": "U2FsdGVkX1/vkQx4ygn6BaMUqf039jmambHH8q7W8Ro=",
    "cpf": "U2FsdGVkX19rO4RQkQZWq3f06EUBjdVOfj1tS2dRnn0="
  },
  {
    "num_cand": "U2FsdGVkX1+6M7MvMXguJpeKNt4tkuuVrQG4rGTYapg=",
    "cpf": "U2FsdGVkX1/FNzYZshCB0rRc7Lw/b1giAeR+yoaQR7Y="
  },
  {
    "num_cand": "U2FsdGVkX1/3X0F0s2Yh7Q2KdWVK7lbHe4Vl8Zuipyw=",
    "cpf": "U2FsdGVkX19l36OlBosDWTkr4alHZBtFL5prdC+jpoQ="
  },
  {
    "num_cand": "U2FsdGVkX1/Q4e8D/XVUw+FDIeFLfiX9CX4WmA9xKAw=",
    "cpf": "U2FsdGVkX18+Wqr1lXcgc8+qsEu86jv3qjvzxJvItao="
  },
  {
    "num_cand": "U2FsdGVkX19tFlbHAUUdJlgXGlEf3Ztj0otwkFum90Y=",
    "cpf": "U2FsdGVkX18nbttuSOMOyN4ypOgHDsaI/vsSNRZx9Vk="
  },
  {
    "num_cand": "U2FsdGVkX1+PrA5d2+Lmxl4MFP7TzczBgdi3x5+0HXg=",
    "cpf": "U2FsdGVkX19d01Ou5eVI8UZVLO5HpFWKibyraLVY1pA="
  },
  {
    "num_cand": "U2FsdGVkX1/ljkJDJG1cK4mbBMEMP1cTqBxTfMaptJ8=",
    "cpf": "U2FsdGVkX18VUNVp0R04zz2ZZZze/qL41ZAbuQMJRhA="
  },
  {
    "num_cand": "U2FsdGVkX1/jvB5uWgKDanofaT2UYD+h4jtLmCBZEZI=",
    "cpf": "U2FsdGVkX19XcGcEVVbZSHEAdlcfjWR6LN2bzfeVYpk="
  },
  {
    "num_cand": "U2FsdGVkX18qN0U4uYPZp4b9EFGfHWxsE8a3CmnwFz4=",
    "cpf": "U2FsdGVkX19J5dVhIrg94Oof6tAEppPhs/or1ubEyJg="
  },
  {
    "num_cand": "U2FsdGVkX18HBFa3eHqjMbTD+EyCxiMoJSEqm1AYyCA=",
    "cpf": "U2FsdGVkX18H56usl4QpR+RP5gRQLuMOhY6KikWadrI="
  },
  {
    "num_cand": "U2FsdGVkX1+biYrTC92jas1aOCNNIuM57JnZCA4UOE0=",
    "cpf": "U2FsdGVkX19wGRSaugz4bgLNi/lQCeCbT/IjegbKCPo="
  },
  {
    "num_cand": "U2FsdGVkX19fcwlLMBr6+rVWd0sZL/nPsloIRbVrpfc=",
    "cpf": "U2FsdGVkX1824A1Y41hiUqZXM2DgA4O7Lhb0tvtS4w8="
  },
  {
    "num_cand": "U2FsdGVkX1/SlvjAke7ukGrS8k6oFYsZiydfpthzG04=",
    "cpf": "U2FsdGVkX191rxsJ7ErFm44fDdS+pgMNNlJHWN0ukSM="
  },
  {
    "num_cand": "U2FsdGVkX1+7DOIkidClp48KHmk1pBsPyM7R7DjJs+8=",
    "cpf": "U2FsdGVkX18bnuna1Gdz5endKJTXE4SppUojd629Hxk="
  },
  {
    "num_cand": "U2FsdGVkX1/3lipVL8mZ5l61tga4hsk7ASW7LtkhV9E=",
    "cpf": "U2FsdGVkX188m2tT82z0uimOcB367htLawyGibVs08M="
  },
  {
    "num_cand": "U2FsdGVkX18S4lD1BRByOx770lYMtwMlm6FeDb0bvaA=",
    "cpf": "U2FsdGVkX19dzQxBo8rKdGGdf0iq5IyVZJXozqe44/E="
  },
  {
    "num_cand": "U2FsdGVkX18J32iqABzyDcUC5KY9DA1kmZaMb5NssE0=",
    "cpf": "U2FsdGVkX18sTU3Mn4iXl3gxgv84FU17RHLYykdDIaI="
  },
  {
    "num_cand": "U2FsdGVkX18kdp+3JQUAn6FDrZ2YC08c23voL1omXW0=",
    "cpf": "U2FsdGVkX1/weDqOpQxVF0ZyYsfeNtefrU8M/M86vJk="
  },
  {
    "num_cand": "U2FsdGVkX19XeJt3O7sGKlvnXnBfZeU2tzpERp8lfnQ=",
    "cpf": "U2FsdGVkX18OshC7PLLzB3Aw1tjjQAj7JlVvvARsYPo="
  },
  {
    "num_cand": "U2FsdGVkX1/Yc1vl8h1pmiZdjMwisYeDdEFq5OJshn4=",
    "cpf": "U2FsdGVkX1+LDYiUXxGvhxx4fkmokNi3mUbF5UhegHA="
  },
  {
    "num_cand": "U2FsdGVkX19S6jJvjtwlAs1YlB9gnhP1LarCGzK/Xpc=",
    "cpf": "U2FsdGVkX1/L8nDk1oG52HsJlbEzPU318m0gd4v/pF4="
  },
  {
    "num_cand": "U2FsdGVkX18mVSSeflxd+z6YI6SJ3CuEZydOHFXsOm0=",
    "cpf": "U2FsdGVkX18LW5JsuQFwX/k+EyuL4oLvEzbJZCmR714="
  },
  {
    "num_cand": "U2FsdGVkX1/+5ozg1vm0H6TJ/b7F8I7JvDn+VwKfQrk=",
    "cpf": "U2FsdGVkX191/yQnveQ7e2o8UW/dJRDeKN+SnVD1r6k="
  },
  {
    "num_cand": "U2FsdGVkX18aFiotva5RWQ0v98g4QojlllYdVAJoAHQ=",
    "cpf": "U2FsdGVkX1+46Ltxy2fI6MyNoOO3gmEPAECexa/CnhI="
  },
  {
    "num_cand": "U2FsdGVkX19GL8iOrx5l9I1HslNYjKbTfudbAUQ79NU=",
    "cpf": "U2FsdGVkX1+WrqK5iW01r4wtv0j6zm7mPfIJ9tZVBqg="
  },
  {
    "num_cand": "U2FsdGVkX1/a0DFvRHUC+Mt6hPyG6dk1jcpLvtamKEU=",
    "cpf": "U2FsdGVkX1+7jERy8riIukt0NeUO++JUOXGOSnEk30g="
  },
  {
    "num_cand": "U2FsdGVkX18vQqQDixw2/orbFZ7SLXhTbAoyA2g+3+s=",
    "cpf": "U2FsdGVkX18qYobjJ4fyAHBCCenZrf5fklq+OdeG11M="
  },
  {
    "num_cand": "U2FsdGVkX18hvXpv/Z+VH9QXQkU3/EyHJVwyyNKr1zw=",
    "cpf": "U2FsdGVkX19Pozbul5ZrA20GHeubDmDdT7qWiMX4GDg="
  },
  {
    "num_cand": "U2FsdGVkX1/CdDaRREoCxbB+t4OSIb9/P6nmbqkO+Ls=",
    "cpf": "U2FsdGVkX19N5dlxVjh4w26ENjgEaAZrn6nRaKXk8zk="
  },
  {
    "num_cand": "U2FsdGVkX18J/OUJOLIGXke30Rl7/VXQGEcxNPfFT3g=",
    "cpf": "U2FsdGVkX19xpd8038GVJCqW/uKYGOOCNL1U9AHyl9I="
  },
  {
    "num_cand": "U2FsdGVkX1/gnop1hJpWqcEwFKLXko2VNCnBDVqL4BI=",
    "cpf": "U2FsdGVkX19AUEBUUAA/iYt3Db8Zx/BCjuJl41YolmA="
  },
  {
    "num_cand": "U2FsdGVkX1/wCbYsby+5LJGRuvArlRjJIADNg4UysHo=",
    "cpf": "U2FsdGVkX18BAE/S6JYLGZrgJncV+pqNEyk4EHmj/Sw="
  },
  {
    "num_cand": "U2FsdGVkX18BPMmjb1OvfMScWg+KH2BnaYDcmvZH7Fk=",
    "cpf": "U2FsdGVkX19e5EBvc/+v92UmozMV/7mrABIRBhw1VIk="
  },
  {
    "num_cand": "U2FsdGVkX19fb/LpMWLykUoTPdZpy96emiDkgXSIsuU=",
    "cpf": "U2FsdGVkX1/oHlrASspILihoJJs1p269RKJX7EtOKMQ="
  },
  {
    "num_cand": "U2FsdGVkX182XzugvLXaPuefyqzko8tRqX/QJl49/2w=",
    "cpf": "U2FsdGVkX1/1Nfv4xfx5H3iiMuBi6ss64mVeUECJTNQ="
  },
  {
    "num_cand": "U2FsdGVkX1+Qq83sdez503C26CoUya+8BHR5RIq58To=",
    "cpf": "U2FsdGVkX18hQ+N/15U1WDujsessMAmWUiNNiru9ev0="
  },
  {
    "num_cand": "U2FsdGVkX1+izs509x0/vJH8nBIbWchVI1vTbUWMIDI=",
    "cpf": "U2FsdGVkX1/Qo1MZ8hoJQr1ydHdrb/fvpiwLeSXumcM="
  },
  {
    "num_cand": "U2FsdGVkX184+yFEu7LKuoOfxj7Ybs8hZPc25Z/8XiA=",
    "cpf": "U2FsdGVkX1+qWH1BevoSETVfY/EA0gRCqupRrPzCAaY="
  },
  {
    "num_cand": "U2FsdGVkX1+JLqyf95+WR3aGPb592Wb1BAe60rfVSFU=",
    "cpf": "U2FsdGVkX18qnnp9gvrt0aLhvR7BlZdekQV1jH4p/sI="
  },
  {
    "num_cand": "U2FsdGVkX1/hDY9W9PC9EcsEgLxGGTvsvE/sjDUTW1w=",
    "cpf": "U2FsdGVkX1/WkcIaiRbI/JSqV7QBx9e5QgfJ+nV2FmQ="
  },
  {
    "num_cand": "U2FsdGVkX1+f8tuT3RJGC5jgaFB+j7locbBaYtHc6SU=",
    "cpf": "U2FsdGVkX19+Br55ErN49D3qkk/vxjE3/Wi7tuwWhlE="
  },
  {
    "num_cand": "U2FsdGVkX18Yc8POSrcT5X6PIOphI12WqY01tiI7TKo=",
    "cpf": "U2FsdGVkX1884Pvl3elZxc7BBaZ9MWwwtgUweIfrwBE="
  },
  {
    "num_cand": "U2FsdGVkX1/BgOwu19YmRBYPlB3LTH1nyHGzK4HOLzk=",
    "cpf": "U2FsdGVkX1/Oy8xc8u91S3l8IYgy/jp5IKImfZBSJKE="
  },
  {
    "num_cand": "U2FsdGVkX19iSMTXM1NvpKDuaq1Lr+gPmMWGasCfgbk=",
    "cpf": "U2FsdGVkX1+al6XIM9F47BUpu8lRK0psNPCwrTmnAyA="
  },
  {
    "num_cand": "U2FsdGVkX18S+Zshp8cWsH3HYUA87pezNBr+gGV9aRk=",
    "cpf": "U2FsdGVkX1/mcT2ETWEQWcugKqhFRy7BmJlmMeKc5NM="
  },
  {
    "num_cand": "U2FsdGVkX1+SAljOuf5WvBH59kQLWOcTw7/MupF8cVI=",
    "cpf": "U2FsdGVkX1/055/PNVDwAQAT9zuO8d0itCxxD4cYygs="
  },
  {
    "num_cand": "U2FsdGVkX18YJAl9Wm+qhLgLKqU0aXzjrKLUzOewzqc=",
    "cpf": "U2FsdGVkX19SnZbyhqgmgyncfvBp9gYYyXbk3rifWqQ="
  },
  {
    "num_cand": "U2FsdGVkX19CVk8g/yCI7a2hB9sIcMNPcGk4nEmxG4U=",
    "cpf": "U2FsdGVkX18PgvjaEpZAJCxNrxQ9QaEM15kycQ9uKzs="
  },
  {
    "num_cand": "U2FsdGVkX18jLLaiRqdlGQKBu9TYicun9BRHxVENx7Q=",
    "cpf": "U2FsdGVkX19g+HnWH3kJNAmuIJ9PMJh70FJDXVIBI94="
  },
  {
    "num_cand": "U2FsdGVkX19JtaWpCpSk9wLv4nPNXuAVBqKP2qU/sWc=",
    "cpf": "U2FsdGVkX1/MEhUAX7QWkmrqiF/B6l/AFqzNqHKm41M="
  },
  {
    "num_cand": "U2FsdGVkX18itClutoTQEXpMksKfd4v7QhP/4a07Wp8=",
    "cpf": "U2FsdGVkX18rd1VAhMsS/W5Anf7q76l3kDJmhqxqcWw="
  },
  {
    "num_cand": "U2FsdGVkX1/KAG6vI4tK1qHPoRtVAvTrgrstI0HGJdg=",
    "cpf": "U2FsdGVkX1+UvhvmEF2q9Rm4J3TYXhj9z28XIZcY7x0="
  },
  {
    "num_cand": "U2FsdGVkX184YscmlzAdtY4OsB1aOGaTMXAWfH0yjGw=",
    "cpf": "U2FsdGVkX1/CQ8RfWaC/aHXh+zM78eLnnvU/TPuE3eM="
  },
  {
    "num_cand": "U2FsdGVkX19ENKonCVygLKwYb5NOdExmfHG/QcUoNfE=",
    "cpf": "U2FsdGVkX188i+qM7zefH95CqTBaN5ptoFXDH8ud1Ms="
  },
  {
    "num_cand": "U2FsdGVkX1/7od1+Sv5cuY6gnhIcC3W/0FcV+EtYxUA=",
    "cpf": "U2FsdGVkX1+/wWve3ml2xcWKVkpWmMjSFtfFRO6xspU="
  },
  {
    "num_cand": "U2FsdGVkX19TKeKTeHDCPz+CEb6XilXdkTBn3vE9BQE=",
    "cpf": "U2FsdGVkX1+SjvJxYO81peg8hcaoszZjJ4NzkEOqfns="
  },
  {
    "num_cand": "U2FsdGVkX19XRZ/H14rdPYPP2m7gfI78UBlRJnVYfdw=",
    "cpf": "U2FsdGVkX1+mxEGlqfcaXcgRIQttT5+J9tDg6LfV3Oo="
  },
  {
    "num_cand": "U2FsdGVkX1/OWUDFcWP4LVnn5SXE4XB5M7YDbuEzt20=",
    "cpf": "U2FsdGVkX1/eoMf+L/Gyxcs7gzPVwwXVPAYsFJV69wY="
  },
  {
    "num_cand": "U2FsdGVkX1+sFdnC7ykNbQ9y7mUJu/Z9hcHugp/6g2E=",
    "cpf": "U2FsdGVkX19IJEmoDanlgUc/TrBcov36ZMJrSd+At0g="
  },
  {
    "num_cand": "U2FsdGVkX1/sS4IuU/rOQkLIeQUg0dQdI1yh0/aI0K0=",
    "cpf": "U2FsdGVkX186PY9FSxbEbXSjajvzUBQLyQ2UXLpzhjg="
  },
  {
    "num_cand": "U2FsdGVkX1/uJZVe2r8ZM2oIcbDQhf+sNuiJIE+PJ68=",
    "cpf": "U2FsdGVkX1/z3B4AnBZUCY/hVgh+xwMLqyMgOU4KPMA="
  },
  {
    "num_cand": "U2FsdGVkX18pqXS6OWehr/0TWLIof/T3oCFRqzbVs3k=",
    "cpf": "U2FsdGVkX1+DBZjnbNSwa/h9oyBpaki8f8uFT1lLDnk="
  },
  {
    "num_cand": "U2FsdGVkX1/0Eb+5D/7MMusA/5fDPn76naw0iY0XmI4=",
    "cpf": "U2FsdGVkX19lfq2yGJhWcRmVThvq/IqfsHyN/FSLBl4="
  },
  {
    "num_cand": "U2FsdGVkX188wdt3kQ+0SIOJukC4NH0vKep+Pb7OBNY=",
    "cpf": "U2FsdGVkX1/enQF3snnaTva+cSoxKtG5p1YrEktoABc="
  },
  {
    "num_cand": "U2FsdGVkX1/SIgFDaCSN4YUW6CVB0KTrIHLsCQ9iQlI=",
    "cpf": "U2FsdGVkX1/AzGmAICOFXVDmiQ6vGfPpFjhnU5/Onyc="
  },
  {
    "num_cand": "U2FsdGVkX1/S5/zrOdvw8NdAecaSNlhvGZ/UsEpUUsA=",
    "cpf": "U2FsdGVkX1/op2duAghzi6hRwkwXM+D/1euJ/YpiuO0="
  },
  {
    "num_cand": "U2FsdGVkX1/SuZ+Zqrx0INzOVogYEJs2GaKKnjbYKQ0=",
    "cpf": "U2FsdGVkX1/5GNnsbxJc3Yt+WupYU65gYT0yLzPkMak="
  },
  {
    "num_cand": "U2FsdGVkX19/e1QPGq5UghsN/9H1aR/Pwpkd9RKyP2U=",
    "cpf": "U2FsdGVkX18DaU1EmJdcQ9LbxT/6+RVxI38Xxm99Dss="
  },
  {
    "num_cand": "U2FsdGVkX1/x/cKAFxtMcKhh6xJAOJRjjyGthwgVQaQ=",
    "cpf": "U2FsdGVkX18yOZU+0tRE5ihcyT115jjKar2ZEPbgrDY="
  },
  {
    "num_cand": "U2FsdGVkX1+iyBYSHJ9/3wZfaGkmF+hDe+KLFZ5zdCc=",
    "cpf": "U2FsdGVkX181kEWRyXIaUlO97a9FaXKdcbrOi2NYwv4="
  },
  {
    "num_cand": "U2FsdGVkX1+OQqDIboIxge4RT1BExxnhOUV/rvdhLHo=",
    "cpf": "U2FsdGVkX1/D/2ooQnuWJgqJRD4FQy35Vd0/nQ3l+yg="
  },
  {
    "num_cand": "U2FsdGVkX1/GL7nHs6Vesg6Vjy/peXfLK8m5iilf1l4=",
    "cpf": "U2FsdGVkX18SwKC3fn6MevtifiSXQDkRk8kUoWjDGV8="
  },
  {
    "num_cand": "U2FsdGVkX18pvlnX+sWg92kSC6E4SUN1688K1zzvM5M=",
    "cpf": "U2FsdGVkX1/OGG0SvreQbvWRH1NRIKpED/Gc+wFhvjE="
  },
  {
    "num_cand": "U2FsdGVkX18/iAXbkRCVCCKlAI0/Dy7eWYq1GahRrmA=",
    "cpf": "U2FsdGVkX18v0fiU5YlDEVj0aSTovbaRqTVHO3eJ4gw="
  },
  {
    "num_cand": "U2FsdGVkX19zpz0v8NgCAv8+yj0ZEU+xYEOzdN3XaGw=",
    "cpf": "U2FsdGVkX196xRJD7gKevAI844eQtjVS/V3p5T+9kmM="
  },
  {
    "num_cand": "U2FsdGVkX18ydagtlh2X2PLjwZGpTkLwJLemBmwp6Ro=",
    "cpf": "U2FsdGVkX187TZ4LzV3UGOqxcKkmBvJkSVLw3An5/QA="
  },
  {
    "num_cand": "U2FsdGVkX1+6Du2DUQQJC2/mAgL1ydy2tTNucADllpI=",
    "cpf": "U2FsdGVkX19k0tFaKJlWmH73fqB0kyhR0DPPHsuGVc0="
  },
  {
    "num_cand": "U2FsdGVkX1/qCRQ2pLS7IK/dc8PPQwZSLdk18Ckh2tk=",
    "cpf": "U2FsdGVkX1+TNXoZnPeM+820kNuz9pS/gIcJEDHB5PQ="
  },
  {
    "num_cand": "U2FsdGVkX18ScWVMRClOQOX9HLIJUtukasQFKHOSpfU=",
    "cpf": "U2FsdGVkX18URK988V682qLgEmpf9SKwRWzZu9wVCXs="
  },
  {
    "num_cand": "U2FsdGVkX183j7407B43t2WMd2WB/CqtSVtJ4UA8bO0=",
    "cpf": "U2FsdGVkX1/PnJNPS+FWoVR+lB5lCEqjti47EzE7R7w="
  },
  {
    "num_cand": "U2FsdGVkX18lVChmmV6J99QnwLWaetrpbMw+y9Dk1L0=",
    "cpf": "U2FsdGVkX1/r9+XfTjJgNKyNw9qavTrG+qt7c6k/CKw="
  },
  {
    "num_cand": "U2FsdGVkX18z5/fO/2h15vnMh1e3dYrXzKTRHu09Efw=",
    "cpf": "U2FsdGVkX1+00TS89rfDMDv/rL0bkottJAZzV80gF8c="
  },
  {
    "num_cand": "U2FsdGVkX19f7lbC4MrlSA2KH2GMaqAQbUBqQKAENeE=",
    "cpf": "U2FsdGVkX181iCOKUEKpqNrdGZoFxuEp3VIAzs59jC8="
  },
  {
    "num_cand": "U2FsdGVkX19ybJu32W1pb3pu1eQyj6DuAdZ7pNZ7xkA=",
    "cpf": "U2FsdGVkX1+scC0Xev0Hh4M2fYSRe8sGZSdHnCbzyPQ="
  },
  {
    "num_cand": "U2FsdGVkX1+xoI9YO8+T3dhXYPzD3bte6l3S487HlqU=",
    "cpf": "U2FsdGVkX18FGBiQZPvvtoSy60l72OfqCsn2kek7hlM="
  },
  {
    "num_cand": "U2FsdGVkX1+MeD1l/De77MneIPU0EycSVBgQJ1lsMlk=",
    "cpf": "U2FsdGVkX19Y902TeTNszovTfVMKU6sLJjx+sNA4UNo="
  },
  {
    "num_cand": "U2FsdGVkX19hPoi7nY8Ntba0fKai33ZwbygIwY0GlxY=",
    "cpf": "U2FsdGVkX1/lc4CaogKniD/OuIDzMtAZNaG3O0un54c="
  },
  {
    "num_cand": "U2FsdGVkX18mO1fbaoO1YO51HTN1VtYiIpOcSXTX7ZM=",
    "cpf": "U2FsdGVkX18AUt09rEby41AONU8xfcrpSvmCYdn/BT4="
  },
  {
    "num_cand": "U2FsdGVkX1/wEn3j/HpUvjVMkgvV2M65uoDrTrhAH0Y=",
    "cpf": "U2FsdGVkX18CwIaIAS2KOblvXzZeAAc97rzsd8XHsJI="
  },
  {
    "num_cand": "U2FsdGVkX1+IdO36cEeCJEO2ZguVdOz5L6D0ssPBDls=",
    "cpf": "U2FsdGVkX1+rML6OUojfw6vzsavp252d2XGYF3y26pA="
  },
  {
    "num_cand": "U2FsdGVkX1+FnMGJTT1lzn4q49lznZy9TMLVhDz+odk=",
    "cpf": "U2FsdGVkX19RYuRUQRe8qW2L1g/Brh2wH+2wzg3Ysb4="
  },
  {
    "num_cand": "U2FsdGVkX1/QV9dI8M5U9xUg6LoxIgBXZe6INoimUSs=",
    "cpf": "U2FsdGVkX18q/30HxisD02KPKps1ZW9JB+1bTxuu9q4="
  },
  {
    "num_cand": "U2FsdGVkX1/DzLxxC03B1A8pFX6YEXoGCDbokc0PoA0=",
    "cpf": "U2FsdGVkX19lV2ewGI6YCdsvvUpKOEqdPMMDZMI4NW4="
  },
  {
    "num_cand": "U2FsdGVkX1901nOAoXcoEho/tICvRVckrEtINBLT93E=",
    "cpf": "U2FsdGVkX19DMoD/HVRCBIyEFGsx+4aZmN/dqbeBU10="
  },
  {
    "num_cand": "U2FsdGVkX1+HJLO/p+Vnf9ugSSEPQO5Vy9TdYUAd1PE=",
    "cpf": "U2FsdGVkX194tgsdbnzocETwdH7lnUrcqrjj+z1pN90="
  },
  {
    "num_cand": "U2FsdGVkX1+b9/hUWtoXz9h1iZmwdxXRgcI7wJP4XRY=",
    "cpf": "U2FsdGVkX1+vaTNdZ4ygZfjAsxZS+Gj6xl9YWF4cjbU="
  },
  {
    "num_cand": "U2FsdGVkX19leg83oNhCur5IFNpu9W7ksh6n6rvouxY=",
    "cpf": "U2FsdGVkX19F7KKDxMlfTcANDb7R3JvjN3w52246H10="
  },
  {
    "num_cand": "U2FsdGVkX18YKdb+75Uvpv043egzDM1OOQ7D1480tJM=",
    "cpf": "U2FsdGVkX184uBW0CWTSIyonb5u5Nd+R1se85PRkSO4="
  },
  {
    "num_cand": "U2FsdGVkX1/FOS3OhmUbhg2seLLc8l7qZyrs3Bqzwzw=",
    "cpf": "U2FsdGVkX1/yqK7xGKJbEcFgcuom3MpBDuodcLsrJr0="
  },
  {
    "num_cand": "U2FsdGVkX19OADkPjlecLR4H6uiNbmjj//l4yKRvA/I=",
    "cpf": "U2FsdGVkX180SYngaguTlid7DPMTKm/O5vjS5oJ/5Gw="
  },
  {
    "num_cand": "U2FsdGVkX19rUl2XZYp1zs9zvMmjvlnMtyz3w0OLR8c=",
    "cpf": "U2FsdGVkX1+5a1sFLfB/FmCCF+KIYiD77JTQNv1IPS4="
  },
  {
    "num_cand": "U2FsdGVkX19uU2i84ACifvAtTFbLdQamvKxJjoqJUd0=",
    "cpf": "U2FsdGVkX1/1TntqgfEJeC5q4rGLyiu14OpZIf+NKUA="
  },
  {
    "num_cand": "U2FsdGVkX1+kmpxk1LY7VVVnnM5bBURjQIih/RNyHok=",
    "cpf": "U2FsdGVkX1+0lGZM5FBI97Rj9GYR0JdqCVvizxvnzMM="
  },
  {
    "num_cand": "U2FsdGVkX18y6BbDx3e7vZNBP4mcAOXLaRCGcLm34v8=",
    "cpf": "U2FsdGVkX1+5dSjcYj4NWmTG7YkbObW1j5T+/c6O4y8="
  },
  {
    "num_cand": "U2FsdGVkX18mlSi2J38u7epYLbdRfw/XRIMqEtSr5wI=",
    "cpf": "U2FsdGVkX18En5tEhhV9PGrEwxMXJ6ZLhcUU/Pg9HA0="
  },
  {
    "num_cand": "U2FsdGVkX19d6TjmwiAbkiOnqvwuQIR6BVQTicFdEPI=",
    "cpf": "U2FsdGVkX18kIFbTFMZZOVOyIV0/f+6KItiCSY8vRgk="
  },
  {
    "num_cand": "U2FsdGVkX1+OxQZhhEXsCIYpywzaS3fEUiojOPTtCmw=",
    "cpf": "U2FsdGVkX18o+Zq0F36vAhAYrbTzwHwXPK4bACAlyO4="
  },
  {
    "num_cand": "U2FsdGVkX1+4NfD7Ya3mf0r9hGT7E19zMtnhgXF9JiU=",
    "cpf": "U2FsdGVkX194yG9FJ5uvus7kHlr18Bblld2KfgazLJk="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2205/2205_impu/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
